<template>
  <div class="navbar-end" v-if="!onLoginPage">
    <!-- Login Button -->
    <div v-if="!isLoggedIn" class="navbar-item">
      <button class="button is-info is-outlined has-text-weight-bold" @click="login" ref="login">
        Log in
      </button>
    </div>

    <!-- Dropdown Menu -->
    <!-- Dropdown Button -->
    <div v-else class="navbar-item has-dropdown is-hoverable">
      <a class="navbar-link">
        <span class="icon is-small mr-1">
          <i class="fa fa-user-tie"></i>
        </span>
        {{userName}}
      </a>

      <!-- Dropdown List -->
      <div class="navbar-dropdown is-boxed">
        <div v-for="(item, index) in dropDownList" :key="index">
          <!-- Dropdown list divider -->
          <hr v-if="item.divider" class="navbar-divider">

          <!-- Dropdown Item -->
          <right-item
            v-else
            :link="item.link"
            :icon="item.icon"
            :text="item.text"
            :class="{active: getCurrentIndex === index}"
            @click="getOption(item.text)">
          </right-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RightItem from './RightItem'

import { TOP_DROPDOWN_LIST } from 'common/const.js'
import { mapState } from 'vuex'

export default {
  name: 'Right',
  data () {
    return {
      dropDownList: TOP_DROPDOWN_LIST
    }
  },
  components: { RightItem },
  computed: {
    ...mapState(['isLoggedIn', 'userName']),
    onLoginPage () {
      return this.$route.path === '/login'
    },
    getCurrentIndex () {
      return this.getPageIndex(this.$route.matched, this.dropDownList)
    }
  },
  methods: {
    login () {
      this.$refs.login.disabled = true
      this.$router.replace('/login')
    },
    getOption (text) {
      const lowerCase = text.toLowerCase()
      this.$router.replace(`/${lowerCase}`)
    },
    getPageIndex (currentPath, dropDownList) {
      if (!currentPath[1]) return -1
      const pageIndex = (item) => item.link === currentPath[1].path
      return dropDownList.findIndex(pageIndex)
    }
  }
}
</script>
<style scoped>
.navbar-dropdown div.hover-item :hover{
  background-color: hsl(0, 0%, 96%);
  cursor: pointer;
}

/* if an item is selected, desactive the option and change background color */
.active {
  background-color: var(--selected-grey-light-color);
  pointer-events: none;
}
</style>
